import { IState } from '../types/AccessorialChargesSlice.types';

export const initialState: IState = {
  filters: {
    search: '',
    type: '',
    per_page: 40,
    page: 1,
    sorted: {
      field: 'name',
      sort: 'asc',
    },
    favorito: null,
  },
  accessorialCharges: [],
};
